import { Component, OnInit, Inject, HostListener } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  AbstractControl
} from '@angular/forms';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { IComponentDetails } from '../../../../../../src/lib/interfaces/component-details.interface';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { StepComponent } from '../stepcomponent.class';
import { PreviousEmploymentInfoComponent } from '../previous-employment-info/previous-employment-info.component';
import { PreviousComponentService } from '../../../../../lib/services/previous-component.service';
import { IConfig, IDescriptionValuePair } from '../../../../../lib/interfaces/config.interface';
import {
  EmploymentInfo,
  CreditApplicationConfig,
  LookupMappingInformation
} from '../../../../../lib/interfaces/credit-application-config.interface';
import { AdditionalInfoComponent } from '../additional-info/additional-info.component';
import { DisableComponentService } from '../../../../../lib/services/disable-component.service';
import { StepType } from '../../../../enum/step-type.enum';
import { CreditAppService } from '../../../../services/credit-app.service';
import { getLookupMappings, validateBothNotZero, validateAllFormFields, getBackButton} from '../../../../utils/utils.functions';
import {CurrentEmployer} from '../../../../interfaces/credit-application.interface';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { NextCTAClick, ServerError } from '../../../../../lib/actions/analytics.action';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { UDOConstant, ErrorType } from '../../../../../lib/enum/analytics.enum';
import createNumberMask from '../../../../../lib/utils/numberMask.functions';
import { INotification, NotificationType } from '../../../../interfaces/notification.interface';
import { NotificationsService } from '../../../../services/notifications.service';
import { HeapIoService } from '../../../../services/heap-io.service';
@Component({
  selector: 'dt-employment-info',
  templateUrl: './employment-info.component.html',
  styleUrls: ['./employment-info.component.scss'],
  standalone: false
})
export class EmploymentInfoComponent implements OnInit {
  type: StepType = StepType.Buyer;
  employmentInfoForm: UntypedFormGroup;
  numberMask: any;
  phoneMask: Array<string | RegExp>;
  employmentInfoConfigData: EmploymentInfo;
  creditAppConfigData: CreditApplicationConfig;
  lookupMappingInfo: LookupMappingInformation[];
  employmentStatusTypes: IDescriptionValuePair[];
  employmentTypes: IDescriptionValuePair[];
  yearsOnJobType: IDescriptionValuePair[];
  monthsOnJobType: IDescriptionValuePair[];
  incomePeriodIntervalType: IDescriptionValuePair[];
  employmentTypeEnumForMappingToJobType: IDescriptionValuePair[];
  employerNameCleared = true;
  formSubmitAttempt = false;
  jobTitleCleared = true;
  employerPhoneCleared = true;
  grossSalaryCleared = true;
  isPreviousEmploymentInfoRequired = false;
  isCustomerRetired = false;
  wordOnlyRegexp: string;
  phonePattern: string;
  formSubmitted = false;
  isSaving = false;
  isBuyNow = false;
  SubPage = '';
  isLegacyCreditApp:boolean = false;

  constructor(private fb: UntypedFormBuilder,
              @Inject('config') public SitecoreConfig: IConfig,
              private nextComponentService: NextComponentService,
              private disableComponentService: DisableComponentService,
              private previousComponentService: PreviousComponentService,
              private creditAppService: CreditAppService,
              private analyticsEventService: AnalyticsEventService,
              private notificationService: NotificationsService,
              private readonly heapIoService: HeapIoService) { }

isMobile() {
  return window.innerWidth < 767 || (window.innerWidth > 768 && window.innerHeight < 480);
}

  public get employment(): CurrentEmployer {
    if (this.creditAppService &&
      this.creditAppService.CreditApplication[this.type] &&
      this.creditAppService.CreditApplication[this.type].financialInformation &&
      this.creditAppService.CreditApplication[this.type].financialInformation.currentEmployer) {
        const currentEmployer: CurrentEmployer = {
          ...this.creditAppService.CreditApplication[this.type].financialInformation.currentEmployer
        };
        if (this.employmentTypeEnumForMappingToJobType){
        if (Number(currentEmployer.salary) === 0 ||
          !this.employmentTypeEnumForMappingToJobType.some( v => v.Value === currentEmployer.jobType)) {
          currentEmployer.jobType = '';
        }
      }
      if(this.employmentStatusTypes){
        if (Number(currentEmployer.salary) === 0 ||
          !this.employmentStatusTypes.some( v => v.Value === currentEmployer.employmentStatus)) {
          currentEmployer.employmentStatus = '';
        }
      }

      if(this.incomePeriodIntervalType){
        if (Number(currentEmployer.salary) === 0 ||
          !this.incomePeriodIntervalType.some(v => v.Value === currentEmployer.frequency)) {
          currentEmployer.frequency = '';
        }
      }
        if (currentEmployer.salary) {
          if (currentEmployer.frequency === 'Monthly') {
            const monthlySalary = Math.round(Number(currentEmployer.salary) * 12);
            currentEmployer.salary = monthlySalary.toString();
          } else {
            currentEmployer.salary = currentEmployer.salary.toString();
          }
        }
        return currentEmployer;
      }
    return {
        employerName: null,
        employmentStatus: '',
        frequency: null,
        jobTitle: null,
        jobType: null,
        monthsAtEmployer: null,
        phoneNumber: null,
        salary: null,
        yearsAtEmployer: null
      };
  }

  ngOnInit() {
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.wordOnlyRegexp = '^[A-Za-z0-9\\s\'\`\’]';
    this.phonePattern = '^[(]{1}[0-9]{3}[)]{1}[ ]{1}[0-9]{3}[-]{1}[0-9]{4}$';
    if (
      this.SitecoreConfig &&
      this.SitecoreConfig.Sitecore &&
      this.SitecoreConfig.Sitecore.CreditApplicationConfig
    ) {
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow;
      this.employmentInfoConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig.EmploymentInfo;
      this.creditAppConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig;
      this.lookupMappingInfo = this.SitecoreConfig.Sitecore.LookupMappingInformation;
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow;
      this.SubPage = this.SitecoreConfig.Sitecore.SubPage ? this.SitecoreConfig.Sitecore.SubPage : '';
      this.isLegacyCreditApp = this.SitecoreConfig.Sitecore.isLegacyCreditApp;
     if(this.isLegacyCreditApp){
      this.updateCtas();
     }

    }

    this.employmentStatusTypes = getLookupMappings(this.lookupMappingInfo, 'EmploymentStatusType');
    this.employmentTypes = getLookupMappings(this.lookupMappingInfo, 'EmploymentType');
    this.yearsOnJobType = getLookupMappings(this.lookupMappingInfo, 'YearsOnJobType');
    this.monthsOnJobType = getLookupMappings(this.lookupMappingInfo, 'MonthsOnJobType');
    this.incomePeriodIntervalType = getLookupMappings(this.lookupMappingInfo, 'IncomePeriodIntervalType');
    this.employmentTypeEnumForMappingToJobType = getLookupMappings(this.lookupMappingInfo, 'EmploymentTypeEnum');

    this.employmentInfoForm = this.fb.group({
      EmploymentStatus: [this.employment.employmentStatus, [Validators.required]],
      EmploymentType: [this.employment.jobType || '', [Validators.required]],
      EmployerName: [this.employment.employerName, [Validators.required, Validators.pattern(this.wordOnlyRegexp + '{0,25}')]],
      JobTitle: [this.employment.jobTitle, [Validators.required, Validators.pattern(this.wordOnlyRegexp + '{0,50}')]],
      EmployerPhone: [this.PhoneNumberUpdate(this.employment.phoneNumber), [Validators.required, Validators.pattern(this.phonePattern)]],
      EmployerDurationGroup: this.fb.group({
        TotalYears: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
          '' :
          this.employment.yearsAtEmployer, [Validators.required]],
        TotalMonths: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
          '' :
          this.employment.monthsAtEmployer, [Validators.required]]
      }, { validator: validateBothNotZero }),
      RetiredDurationGroup: this.fb.group({
        TotalYearsRetired: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
           '' :
           this.employment.yearsAtEmployer],
        TotalMonthsRetired: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
           '' :
           this.employment.monthsAtEmployer]
      }, { validator: validateBothNotZero }),
      GrossSalary: [this.employment.salary || '', [Validators.required]]
      // IncomeFrequency: [this.employment.frequency || '', [Validators.required]]
    });

    if (this.employment.employerName) {
      this.employmentInfoForm.markAsDirty();
    }
    
    this.employmentInfoForm.get('EmployerDurationGroup.TotalYears').valueChanges.subscribe(value => {
      if (value && value <= 1) {
        this.isPreviousEmploymentInfoRequired = true;
      } else {
        this.isPreviousEmploymentInfoRequired = false;
      }
    });

    this.employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').valueChanges.subscribe(value => {
      if (value && value <= 1) {
        this.isPreviousEmploymentInfoRequired = true;
      } else {
        this.isPreviousEmploymentInfoRequired = false;
      }
    });

    // tslint:disable-next-line: no-string-literal
    this.setEmploymentStatusValidators(this.employmentInfoForm.value['EmploymentStatus'], false);

    this.employmentInfoForm.get('EmploymentStatus').valueChanges
      .subscribe(employmentStatus => {
        this.setEmploymentStatusValidators(employmentStatus);
    });
 
    this.numberMask = createNumberMask({
      prefix: ''
    });

    if (this.employmentInfoForm.valid) {
      this.formSubmitted = true;
      this.employmentInfoForm.markAsPristine();
    }

    validateAllFormFields(this.employmentInfoForm);

    if (this.type === StepType.CoBuyer) {
      this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
        if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
          this.employmentInfoForm.markAsDirty();
        }
      });
    }

    if(this.isBuyNow){
      if(this.type === StepType.Buyer){
        this.heapIoService.trackPageview('credit-application/employment-information');
      }
      else if(this.type === StepType.CoBuyer){
        this.heapIoService.trackPageview('credit-application/cobuyer-employment-information');
      }


    }
  }

  setEmploymentStatusValidators(employmentStatus: string, resetRetiredTime = true) {
    const totalYearsControl = this.employmentInfoForm.get('EmployerDurationGroup.TotalYears');
    const totalMonthsControl = this.employmentInfoForm.get('EmployerDurationGroup.TotalMonths');
    const totalYearsRetiredControl = this.employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired');
    const totalMonthsRetiredControl = this.employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired');
    const employmentTypeControl = this.employmentInfoForm.get('EmploymentType');
    const employerNameControl = this.employmentInfoForm.get('EmployerName');
    const jobTitleControl = this.employmentInfoForm.get('JobTitle');
    const employerPhoneControl = this.employmentInfoForm.get('EmployerPhone');

    if (employmentStatus === 'Retired') {

      totalYearsRetiredControl.setValidators([Validators.required]);
      totalMonthsRetiredControl.setValidators([Validators.required]);
      employmentTypeControl.setValidators(null);
      employerNameControl.setValidators(null);
      jobTitleControl.setValidators(null);
      employerPhoneControl.setValidators(null);
      totalYearsControl.setValidators(null);
      totalMonthsControl.setValidators(null);

      if (resetRetiredTime) {
        totalYearsRetiredControl.reset('');
        totalMonthsRetiredControl.reset('');
      }

      totalYearsControl.reset('');
      totalMonthsControl.reset('');
      employmentTypeControl.reset('');
      employerNameControl.reset('');
      jobTitleControl.reset('');
      employerPhoneControl.reset('');

      this.isCustomerRetired = true;

      // tslint:disable-next-line: no-string-literal
    } else if (this.employmentInfoForm.value['EmploymentStatus'] === 'Retired') {

      totalYearsRetiredControl.setValidators(null);
      totalMonthsRetiredControl.setValidators(null);
      employmentTypeControl.setValidators([Validators.required]);
      employerNameControl.setValidators([Validators.required]);
      jobTitleControl.setValidators([Validators.required]);
      employerPhoneControl.setValidators([Validators.required]);
      totalYearsControl.setValidators([Validators.required]);
      totalMonthsControl.setValidators([Validators.required]);

      totalYearsRetiredControl.reset('');
      totalMonthsRetiredControl.reset('');
      totalYearsControl.reset('');
      totalMonthsControl.reset('');
      employmentTypeControl.reset('');
      employerNameControl.reset('');
      jobTitleControl.reset('');
      employerPhoneControl.reset('');

      this.isCustomerRetired = false;
    }

    employmentTypeControl.updateValueAndValidity();
    employerNameControl.updateValueAndValidity();
    jobTitleControl.updateValueAndValidity();
    employerPhoneControl.updateValueAndValidity();
    totalYearsRetiredControl.updateValueAndValidity();
    totalMonthsRetiredControl.updateValueAndValidity();
    totalYearsControl.updateValueAndValidity();
    totalMonthsControl.updateValueAndValidity();
  }

  clearValidations(formControl: AbstractControl) {
    if (formControl.invalid) {
      formControl.reset();
      this.controlCleared(formControl);
    }
  }

  controlCleared(formControl) {
    switch (this.getControlName(formControl)) {
      case 'EmployerName':
        this.employerNameCleared = true;
        break;
      case 'JobTitle':
        this.jobTitleCleared = true;
        break;
      case 'EmployerPhone':
        this.employerPhoneCleared = true;
        break;
      case 'GrossSalary':
        this.grossSalaryCleared = true;
        break;
      // tslint:disable-next-line: no-switch-case-fall-through
      default:
        break;
    }
  }

  PhoneNumberUpdate(phone) {
    if (phone) {
      let p = phone.match(/\d/g);
      p = p.join('');
      return '(' + p.substr(0, 3) + ') ' + p.substr(3, 3) + '-' + p.substr(6, 4);
    }
    return '';
  }

  getControlName(c: AbstractControl): string | null {
    const formGroup = c.parent && c.parent.controls;
    return formGroup ? Object.keys(formGroup).find(name => c === formGroup[name]) : null;
  }

  goBack() {
    let currentComponent: IComponentDetails;
    if (this.type === StepType.Buyer) {
      currentComponent = {
        groupName: ComponentGroup.EmploymentInfo,
        component: new StepComponent(EmploymentInfoComponent,
          ComponentName.EmploymentInfoComponent, ComponentGroup.EmploymentInfo, true),
        componentName: ComponentName.EmploymentInfoComponent
      };
    } else {
      currentComponent = {
        groupName: ComponentGroup.CoBuyerEmployment,
        component: new StepComponent(EmploymentInfoComponent,
          ComponentName.CoBuyerEmploymentInfoComponent, ComponentGroup.CoBuyerEmployment, true, StepType.CoBuyer),
        componentName: ComponentName.CoBuyerEmploymentInfoComponent
      };
    }

    /*if (this.type === StepType.CoBuyer) {
      const ca = { ...this.creditAppService.CreditApplication };
      this.creditAppService.SaveCreditAppAndForget(ca);
    }*/

    this.previousComponentService.loadComponent(currentComponent);
  }

  goNext() {
    let ca:any;
    this.formSubmitAttempt = true;
    this.employerNameCleared = false;
    this.jobTitleCleared = false;
    this.employerPhoneCleared = false;
    this.grossSalaryCleared = false;

    if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
      ca = { ...this.creditAppService.LegacyCreditApplication };
    }else{
      ca = { ...this.creditAppService.CreditApplication };
    }

    this.setPreviousEmploymentInfoRequired(ca);
    getBackButton();
    
    if ((this.employmentInfoForm.valid && this.employmentInfoForm.dirty)
    || (this.employmentInfoForm.valid && !this.formSubmitted)) {

        const stepCount = (this.type === StepType.Buyer ? 4 : 10);
        /* istanbul ignore else */
        // if (ca.step <= stepCount || ca.step === 13) {
        ca.step = stepCount;
        // }

        const employmentStatus = this.employmentInfoForm.get('EmploymentStatus').value;
        ca[this.type].financialInformation.currentEmployer = {
          employerName: this.employmentInfoForm.get('EmployerName').value,
          employmentStatus,
          // frequency: this.employmentInfoForm.get('IncomeFrequency').value,
          jobTitle: this.employmentInfoForm.get('JobTitle').value,
          jobType: this.employmentInfoForm.get('EmploymentType').value,
          phoneNumber: this.employmentInfoForm.get('EmployerPhone').value,
          salary: this.employmentInfoForm.get('GrossSalary').value.replace(/,\s?/g, '').replace(/\b(0(?!\b))+/g, ''),
          yearsAtEmployer: employmentStatus !== 'Retired' ?
            // tslint:disable-next-line: max-line-length
            this.employmentInfoForm.get('EmployerDurationGroup.TotalYears').value : this.employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').value,
          monthsAtEmployer: employmentStatus !== 'Retired' ?
            // tslint:disable-next-line: max-line-length
            this.employmentInfoForm.get('EmployerDurationGroup.TotalMonths').value : this.employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').value
        };

        this.setPreviousEmploymentInfoRequired(ca);

        this.isSaving = true;
        if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
          ca[this.type].financialInformation.currentEmployer.job = 0;
          ca[this.type].financialInformation.currentEmployer.salary = parseInt( ca[this.type].financialInformation.currentEmployer.salary);
          ca[this.type].financialInformation.currentEmployer.frequency = 0;
          ca[this.type].financialInformation.currentEmployer.yearsAtEmployer = parseInt( ca[this.type].financialInformation.currentEmployer.yearsAtEmployer);
          ca[this.type].financialInformation.currentEmployer.monthsAtEmployer = parseInt( ca[this.type].financialInformation.currentEmployer.monthsAtEmployer);

        }
        this.creditAppService.SaveCreditApp(ca,this.SubPage).subscribe(response => {
          if (response.isSuccess) {
            this.isSaving = false;
            this.formSubmitted = true;
            this.employmentInfoForm.markAsPristine();
            this.loadNextComponent();
          } else {
            this.isSaving = false;
            this.reportErrorResponse(response);
          }
        }, error => {
          this.isSaving = false;
          this.reportErrorResponse(error);
        });
    } else {
      if (this.employmentInfoForm.valid) {
        this.loadNextComponent();
      }
    }
  }

  setPreviousEmploymentInfoRequired(ca) {
    if (ca[this.type].financialInformation.currentEmployer && ca[this.type].financialInformation.currentEmployer.yearsAtEmployer <= 1) {
      this.isPreviousEmploymentInfoRequired = true;
    } else {
      this.isPreviousEmploymentInfoRequired = false;
      ca[this.type].financialInformation.previousEmployer = null;
    }
  }

  loadNextComponent() {
    let nextComponent: IComponentDetails;
    let componentToBeDisabled: IComponentDetails;
    if (this.isPreviousEmploymentInfoRequired) {
      componentToBeDisabled = null;
      if (this.type === StepType.Buyer) {
        nextComponent = {
          groupName: ComponentGroup.EmploymentInfo,
          component: new StepComponent(
            PreviousEmploymentInfoComponent,
            ComponentName.PreviousEmploymentInfoComponent,
            ComponentGroup.EmploymentInfo,
            true
          ),
          componentName: ComponentName.PreviousEmploymentInfoComponent
        };
        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(
            new StepComponent(
              EmploymentInfoComponent,
              ComponentName.EmploymentInfoComponent,
              ComponentGroup.EmploymentInfo,
              true,
              this.type
            )
          )
        );
      } else {
        nextComponent = {
          groupName: ComponentGroup.CoBuyerEmployment,
          component: new StepComponent(
            PreviousEmploymentInfoComponent,
            ComponentName.CoBuyerPreviousEmploymentInfoComponent,
            ComponentGroup.CoBuyerEmployment,
            true,
            StepType.CoBuyer
          ),
          componentName: ComponentName.CoBuyerPreviousEmploymentInfoComponent
        };
        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(
            new StepComponent(
              EmploymentInfoComponent,
              ComponentName.CoBuyerEmploymentInfoComponent,
              ComponentGroup.CoBuyerEmployment,
              true,
              this.type
            )
          )
        );
      }
    } else {
      if (this.type === StepType.Buyer) {
        componentToBeDisabled = {
          groupName: ComponentGroup.EmploymentInfo,
          component: new StepComponent(
            PreviousEmploymentInfoComponent,
            ComponentName.PreviousEmploymentInfoComponent,
            ComponentGroup.AdditionalInfo,
            false
          ),
          componentName: ComponentName.PreviousEmploymentInfoComponent
        };
        nextComponent = {
          groupName: ComponentGroup.AdditionalInfo,
          component: new StepComponent(
            AdditionalInfoComponent,
            ComponentName.AdditionalInfoComponent,
            ComponentGroup.AdditionalInfo,
            true
          ),
          componentName: ComponentName.AdditionalInfoComponent
        };
        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(
            new StepComponent(
              EmploymentInfoComponent,
              ComponentName.EmploymentInfoComponent,
              ComponentGroup.EmploymentInfo,
              true,
              this.type
            )
          )
        );
      } else {
        componentToBeDisabled = {
          groupName: ComponentGroup.CoBuyerEmployment,
          component: new StepComponent(
            PreviousEmploymentInfoComponent,
            ComponentName.CoBuyerPreviousEmploymentInfoComponent,
            ComponentGroup.CoBuyerEmployment,
            true,
            StepType.CoBuyer
          ),
          componentName: ComponentName.CoBuyerPreviousEmploymentInfoComponent
        };
        nextComponent = {
          groupName: ComponentGroup.CoBuyerAdditional,
          component: new StepComponent(
            AdditionalInfoComponent,
            ComponentName.CoBuyerAdditionalInfoComponent,
            ComponentGroup.CoBuyerAdditional,
            true,
            StepType.CoBuyer
          ),
          componentName: ComponentName.CoBuyerAdditionalInfoComponent
        };
        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(
            new StepComponent(
              EmploymentInfoComponent,
              ComponentName.CoBuyerEmploymentInfoComponent,
              ComponentGroup.CoBuyerEmployment,
              true,
              this.type
            )
          )
        );
      }
    }
    this.disableComponentService.disableComponent(componentToBeDisabled);
    this.nextComponentService.loadComponent(nextComponent);
    return { componentToBeDisabled, nextComponent };
  }

  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSaved
    };
    this.analyticsEventService.reportAnalyticsEvent(
          new ServerError(new StepComponent(EmploymentInfoComponent,
                                            ComponentName.EmploymentInfoComponent,
                                            ComponentGroup.EmploymentInfo, true, this.type),
                                            analyticsErrorResponse));
  }

  updateCtas() {
    try {
      (window as any).standalonePrequal.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }

 

  @HostListener('window:resize', ['$event'])
  reSize(e) {
    /* istanbul ignore next */
   this.isMobile();
  }

}
